const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/label-boxes/Basic"),
    name: "Invoice No",
    visible: true,
    props: {
      label: "INVOICE NO",
      value: "number",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/label-boxes/Agent"),
    name: "Agent",
    visible: true,
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/label-boxes/Basic"),
    name: "Reference",
    visible: true,
    props: {
      label: "ITI REFERENCE",
      labeler: (data) => data.itinerary.reference,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/label-boxes/Basic"),
    name: "Supplier",
    visible: true,
    props: {
      label: "SUPPLIER",
      labeler: (data) => `${data.supplier.name}`,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/label-boxes/Basic"),
    name: "Amount",
    visible: true,
    props: {
      label: "AMOUNT",
      labeler: (data) =>
        `${Number(data.amount).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })} ${data.currencyCode}`,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/label-boxes/Basic"),
    name: "Invoice Date",
    visible: true,
    props: {
      label: "INVOICE DATE",
      value: "createdAt",
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/finances/purchase-invoices/pi-boxes-list.js